module.exports = __webpack_public_path__ + "img/logo.170134ff.svg";